import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        user: {},
        posts: {},
        btn: false
    },

    mutations: {
        SET_USER: (state, data) => {
            state.user = data
        },
        SET_POSTS: (state, data) => {
            state.posts = data
        },
        SET_BTN: (state, data) => {
            state.btn = data
        }
    }
})

export default store


// WEBPACK FOOTER //
// ./src/store/index.js